<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">{{ title }}</h4>
    <button mat-icon-button mat-dialog-close>
      <mat-icon fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <p>{{ content }}</p>
  </mat-dialog-content>
  <mat-dialog-actions cdkFocusRegionstart>
    <button mat-raised-button class="button--secondary button--pad-right" [mat-dialog-close]="false">{{ cancelText }}</button>
    <button mat-raised-button [mat-dialog-close]="true">{{ confirmText }}</button>
  </mat-dialog-actions>
</div>
